export const getName = () => `${new Date().toString().replace(/:/g, '')}`;
export const definedProps = obj =>
  Object.entries(obj)
    .filter(([, value]) => value !== undefined)
    .reduce((acc, cur) => ({ ...acc, [cur[0]]: cur[1] }), {});
